import { render, staticRenderFns } from "./StatusCount.vue?vue&type=template&id=0f2cfa9f&"
import script from "./StatusCount.vue?vue&type=script&lang=ts&"
export * from "./StatusCount.vue?vue&type=script&lang=ts&"
import style0 from "./StatusCount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports